const ibes = state => state.ibes
const currentIbe = state => state.ibes[state.currentIbe]

export default {
  ibes,
  currentIbe
}
